import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import Swal from "sweetalert2";
import ReportResult from "./ReportResult";
import axios from "axios";
import { DecryptED } from "../../DecryptJS/Decrypt";
const useStyles = makeStyles({
  page: {
    minHeight: "100vh",
    backgroundColor: "#f4f6fb",
    padding: "24px",
    boxSizing: "border-box",
  },
  heading: {
    margin: "0 0 20px",
    padding: 0,
    textAlign: "center",
  },
  filterCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    boxShadow: "0 1px 2px rgba(15,23,42,0.06), 0 8px 24px rgba(15,23,42,0.06)",
    padding: "20px 24px",
    maxWidth: "900px",
    margin: "0 auto 24px",
    boxSizing: "border-box",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
    width: "100%",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  input: {
    width: "200px",
    height: "40px",
    padding: "0 12px",
    backgroundColor: "#fff",
    color: "#1f2937",
    border: "1px solid #e2e8f0",
    borderRadius: "10px",
    fontSize: "0.95rem",
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#1f2937",
  },
  button: {
    height: "40px",
    backgroundColor: "#1565c0",
    padding: "0 24px",
    color: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(21,101,192,0.25)",
    "&:hover": {
      backgroundColor: "#0d47a1",
    },
    "&:disabled": {
      backgroundColor: "#cbd5e1",
      color: "#fff",
    },
  },
});

const Report = () => {
  const classes = useStyles();
  let { sid, userid } = useParams();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchReports = async (from, to) => {
    setLoading(true);
    try {
      const response = await axios({
        method: "POST",
        url: "https://marcopolo.prisms.in/api/admin/lessonPlan/reportBydate",
        data: {
          sid: DecryptED(sid),
          staff: DecryptED(userid),
          startDate: from,
          endDate: to,
        },
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      });
      setReports(Array.isArray(response.data) ? response.data : []);
    } catch (e) {
      console.error(e);
      Swal.fire("Error", "Could not load lesson reports. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (startDate && endDate && startDate > endDate) {
      return Swal.fire("Warning", "Start date must be before end date", "warning");
    }
    fetchReports(startDate, endDate);
  };

  useEffect(() => {
    const now = new Date();
    const currentDate = now.toISOString().split("T")[0];
    const lastMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate())
      .toISOString()
      .split("T")[0];

    setEndDate(currentDate);
    setStartDate(lastMonthDate);
    fetchReports(lastMonthDate, currentDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.page}>
      <h3
        className={classes.heading}
        style={{ color: "#1f2937", fontSize: "24px" }}
      >
        Lesson Reports
      </h3>
      <form className={classes.filterCard} onSubmit={submitHandler}>
        <div className={classes.filterRow}>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="fromDate">
              Start Date
            </label>
            <input
              id="fromDate"
              className={classes.input}
              type="date"
              onChange={(e) => setStartDate(e.target.value)}
              name="fromDate"
              value={startDate}
              max={endDate || undefined}
            />
          </div>
          <div className={classes.field}>
            <label className={classes.label} htmlFor="toDate">
              End Date
            </label>
            <input
              id="toDate"
              className={classes.input}
              type="date"
              name="toDate"
              onChange={(e) => setEndDate(e.target.value)}
              value={endDate}
              min={startDate || undefined}
            />
          </div>
        </div>
        <Button
          type="submit"
          className={classes.button}
          variant="contained"
          disabled={loading}
        >
          {loading ? "Loading…" : "Submit"}
        </Button>
      </form>
      {loading ? (
        <p style={{ textAlign: "center", color: "#1565c0", marginTop: "20px" }}>
          Loading lesson reports…
        </p>
      ) : (
        <ReportResult
          reports={reports}
          setReports={setReports}
          startDate={startDate}
          endDate={endDate}
          userid={userid}
          sid={sid}
        />
      )}
    </div>
  );
};

export default Report;
